import React from 'react'
import PropTypes from 'prop-types'

import PrimaryButton from 'components/PrimaryButton'
import { OVERLAY } from 'components/AuthModal/styles'
import Overlay from 'components/AuthModal/components/Overlay'
import Modal from 'components/AuthModal/components/Modal'

import logo from 'assets/images/logoPrimary.svg'

const WelcomeModal = ({ show, onClose, onDiscoverClick }) => (
  <Overlay show={show} className={OVERLAY} autoFocus={false} onClose={onClose}>
    <Modal outerClassName="bg-transparent" innerClassName="overflow-visible">
      <div
        className="mx-4 p-14 px-5 pt-10 rounded-xl bg-ashBlack md:mx-0 md:p-16 md:pt-12"
        style={{
          filter: 'drop-shadow(0px 20px 80px rgba(255, 255, 255, 0.2))',
        }}
      >
        <div className="flex flex-col items-center text-center text-white w-full md:w-80">
          <img
            src={logo}
            className="w-14 h-14"
            alt="logo"
            style={{
              filter: 'drop-shadow(0px 4px 30px rgba(255, 255, 255, 0.25))',
            }}
          />
          <div className="font-ownersWide text-white font-semibold text-3xl my-6">
            Congratulations, you have full access
          </div>
          <div className="text-base opacity-50 mb-14">
            Teleport is invite only to make sure you always meet the best people.
          </div>
          <PrimaryButton className="text-base h-14 w-48" onClick={onDiscoverClick}>
            Discover Events
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  </Overlay>
)

WelcomeModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
}

export default WelcomeModal
